import { render, staticRenderFns } from "./RegisterHint.vue?vue&type=template&id=be5ff362"
var script = {}
import style0 from "./RegisterHint.vue?vue&type=style&index=0&id=be5ff362&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports